module.exports = __webpack_public_path__ + "static/media/RLC_8430a.143876fe.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/kukenan/RLC_8430a.JPG
// module id = 103
// module chunks = 0